import React from 'react';
import { Layout } from '@layout/Layout';
import OKRMyView from '../components/OKRMyView';
import { Box, Typography, Breadcrumbs, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const MyOKRs: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Layout>
            <Box sx={{ p: 3 }}>
                <Breadcrumbs sx={{ mb: 2 }}>
                    <Link
                        underline="hover"
                        color="inherit"
                        sx={{ cursor: 'pointer' }}
                        onClick={() => navigate('/okr')}
                    >
                        OKRs
                    </Link>
                    <Typography color="text.primary">My OKRs</Typography>
                </Breadcrumbs>
                <OKRMyView />
            </Box>
        </Layout>
    );
};

export default MyOKRs;
